import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TimeService {
    constructor() {
    }

    public convertTime(time: string, separator?: boolean): string {
        if (!time || time === '') {
            return null;
        }

        if (separator) {
            return time.substring(0, 2) + ':' + time.substring(2);
        }

        return time.replace(':', '');
    }

    public formatToTimeString(time: number): string {
        return time < 10 ? '0' + time : time.toString();
    }

    public timeDifference(from: string, to: string): number {
        const timeFrom = this.getMilliseconds(from);
        const timeTo = this.getMilliseconds(to);
        let difference = 0;

        if (timeFrom < timeTo) {
            difference = Math.abs(timeTo - timeFrom);
        } else if (timeFrom === timeTo) {
            return 0;
        } else {
            const time00 = this.getMilliseconds('00:00');
            const time24 = this.getMilliseconds('24:00');
            difference = Math.abs(timeTo - time00 + (time24 - timeFrom));
        }

        return Math.round(difference / 60000);
    }

    public getDate(time: string): Date {
        return new Date(`1970-01-01T${time}Z`);
    }

    public addMinutes(date: Date, minutes: number): Date {
        return new Date(date.getTime() + minutes * 60000);
    }

    public addMinutesToTime(time: string, minutes: number): string {
        let date = this.getDate(time);
        date = this.addMinutes(date, minutes);

        return `${date
            .getUTCHours()
            .toString()
            .padStart(2, '0')}:${date
            .getUTCMinutes()
            .toString()
            .padStart(2, '0')}`;
    }

    public extractHours(timeSeconds: number): number {
        return Math.floor(timeSeconds / 3600);
    }

    public extractMinutes(timeSeconds: number): number {
        return Math.floor((timeSeconds % 3600) / 60);
    }

    public convertStringToSeconds(timeString: string): number {
        timeString = timeString.replace(":", "");
        return (+timeString.slice(0, 2) * 3600) + (+timeString.slice(2) * 60);
    }

    private getMilliseconds(time: string): number {
        return new Date(`1970-01-01T${time}Z`).getTime();
    }
}
